import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Pagination } from '~/components/blocks';
import { patientPageInfoState } from '~/state/patient/atoms';

export const PatientPagination = () => {
  const [{ page, totalPage, totalCount }, setState] = useAtom(patientPageInfoState);

  const handleChangePage = useCallback(
    (newPage: number) => setState((_state) => ({ ..._state, page: newPage })),
    [setState],
  );

  return totalCount > 0 ? (
    <Pagination currentPage={page} totalPage={totalPage} onChange={handleChangePage} />
  ) : null;
};
